import React from "react";
import { about } from "@/data";

const Index = () => {
  const [isSmallScreen, setIsSmallScreen] = React.useState(false);
  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      const currentSize = window.innerWidth;
      if (currentSize > 992) {
        setIsLargeScreen(true);
      } else {
        setIsLargeScreen(false);
      }

      if (currentSize < 400) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
    };

    window.addEventListener("resize", handleResize, { passive: true });

    return () => window.removeEventListener("resize", handleResize);
  }, [isSmallScreen]);

  React.useEffect(() => {
    const currentSize = window.innerWidth;
    if (currentSize > 992) {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }

    if (currentSize < 400) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  }, []);

  return (
    <div className="bg-light pb-md-5">
      <div className="bg-blue">
        <div className="container text-left py-3 py-md-5">
          <div className="py-5 small-container">
            <h2 className="fs-1 fw-bold mb-3 text-white">
              Hey, I'm Hanzala - Technical Expert
            </h2>
            <p className="fs-4 col-md-10 fw-normal text-white py-3">
              I am a full-stack developer with a passion for creating
              exceptional web and app experiences. I have a strong foundation in
              both front-end and back-end development, and I am always looking
              to learn new technologies and improve my skills. I am a creative
              problem solver who enjoys working on challenging projects and
              collaborating with others to create innovative solutions.
            </p>
          </div>
        </div>
      </div>

      <div className="position-relative pb-5">
        <div
          className="bg-blue position-absolute d-block w-100 bottom-0 start-0 end-0 top-0"
          style={{
            height: "14rem",
            zIndex: "0",
          }}
        />
        <div
          className="container position-relative mb-4"
          style={{
            zIndex: 11,
          }}
        >
          <div className="row rounded-4 shadow bg-light">
            {about.services.map(
              (
                {
                  iconClass,
                  title,
                  description,
                  aboutMe,
                  aboutMeDescription,
                  tools,
                  toolsDescription,
                },
                index
              ) => {
                return (
                  <div
                    className={`col-lg-6 ${
                      index === 1 && isLargeScreen
                        ? "border-start border-end"
                        : index === 1 && !isLargeScreen
                          ? "border-top border-bottom"
                          : ""
                    } text-center`}
                    key={index}
                  >
                    <div className="px-3 py-5 text-center">
                      <div className="fs-1 text-blue">
                        <i className={`${iconClass}`}></i>
                      </div>
                      <h2 className="fs-2 my-3 fw-bold text-capitalize">
                        {title}
                      </h2>

                      <p className="mb-5 fs-4 col-8 mx-auto my-5">
                        {description}
                      </p>

                      <div className="my-5">
                        <p className="py-2 fs-4 text-blue">{aboutMe}</p>
                        <p className="m-0 fw-normal fs-5">
                          {aboutMeDescription}
                        </p>
                      </div>

                      <div className="my-5">
                        <p className="mb-3 text-blue fs-4">{tools}</p>
                        <div className="justify-content-center d-flex flex-wrap">
                          {toolsDescription.map((toolsDescription, i) => (
                            <p
                              className="mb-2 fw-normal fs-5"
                              style={{ width: "33.33%" }}
                              key={i}
                            >
                              {toolsDescription}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
